import { Injectable } from "@angular/core";
import { ShiftModel } from "@m481/mp-sdk-ng";
import { IListDataResponse } from "@m481/mp-sdk-ng/lib/models/reponses/list-data.response";
import { lastValueFrom, Observable } from "rxjs";

import { AppConstants } from "@mp/app.constants";
import { ShiftEntity, ShiftEntityHelper } from "@mp/common/entities/shift.entity";
import { BaseStoreService } from "./base-store.service";

@Injectable({
    providedIn: "root"
})
export class ShiftStoreService extends BaseStoreService<ShiftEntity, ShiftModel> {
    constructor() {
        super({
            storageKey: AppConstants.StorageKeys.STORE.SHIFT
        });
        this.init();
    }

    /**
     * Get all conflicting user ids for a shift id that belongs to a series
     * @param shiftId in which we want to add a user
     * @returns conflicting user ids
     */
    public async getConflictingUserIdsThroughSeriesByShiftId(shiftId: string): Promise<Array<string>> {
        try {
            const response = await lastValueFrom(this.mpSdkService.getAssignmentsPerShift(shiftId));
            if (response?.success) {
                return response?.assignments || [];
            }
        } catch (e) {
            this.log.err("Error checking conflicts", e);
        }

        return [];
    }

    /*
     * Base store service SDK methods implementation
     */

    protected mapEntityToModel(entity: ShiftEntity): ShiftModel {
        return ShiftEntityHelper.toModel(entity);
    }

    protected mapModelToEntity(model: ShiftModel): ShiftEntity {
        return ShiftEntityHelper.fromModel(model);
    }

    protected sdkGet$(): Observable<IListDataResponse<ShiftModel>> {
        return this.mpSdkService.getShifts();
    }

    protected sdkCreate$(model: ShiftModel): Observable<ShiftModel> {
        return this.mpSdkService.saveShift(model);
    }

    protected sdkUpdate$(model: ShiftModel): Observable<ShiftModel> {
        return this.mpSdkService.saveShift(model);
    }

    protected sdkDelete$(id: string): Observable<boolean> {
        return this.mpSdkService.deleteShift(id);
    }
}
